import { PostingType } from 'types/Posting';

export type PaymentReceiptSort = 'date' | 'name' | 'amount';

export type PaymentReceiptOrder = 'asc' | 'desc';

export type PaymentReceiptsFilters = {
	beneficiary?: string;
	search?: string;
	dateFrom?: string;
	dateTo?: string;
	page?: number;
	size?: number;
	sort?: PaymentReceiptSort;
	order?: PaymentReceiptOrder;
};

export type PaymentReceiptAccount = {
	branch: string | null;
	account: string | null;
};

export type PaymentReceipt = {
	posting_id: string;
	type: PostingType;
	amount: number;
	executed_at: string;
	description: string | null;
	holder_name: string;
	holder_taxpayer_id: string;
	account: PaymentReceiptAccount;
	beneficiary_name: string | null;
};

export enum PaymentReceiptFileStatus {
	READY = 'READY',
	PENDING = 'PENDING',
}

export type PaymentReceiptFile = {
	status: PaymentReceiptFileStatus;
	url: string | null;
	file_name: string | null;
	expires_in: number | null;
};

/**
 * Estado por linha do download do comprovante:
 * - pending: a API respondeu 202 (PDF ainda sendo gerado) → permite nova tentativa;
 * - unavailable: a API respondeu 404 → não adianta tentar de novo.
 */
export type PaymentReceiptDownloadState = 'pending' | 'unavailable';
